var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"mr-2",attrs:{"src":"https://ucarecdn.com/d9c88ec0-3051-4966-a467-ca26e94489b6/-/format/auto/","alt":"Lightspeed POS Logo","width":"16","height":"16"}})
}
var staticRenderFns = []

export { render, staticRenderFns }